import React from 'react'
import { connect } from 'react-redux'
import { store } from '../../store'
import { Translate } from '../../modules/Translations'

const Footer = ({translations, locales, currentLocale}) => {
    return (
        <footer id="MainFooter">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        „От уста на ухо“... до Internet“ (Проект № ФП-17 ФЛФ-004 / 16.05.2017)
                    </div>
                    {/* <div className="col-md-6 text-right">
                        <nav className="nav nav-pills justify-content-end">
                            {Object.keys(locales).map(key => (
                                <a  hrefLang={key} title={translations[key][locales[key]]}
                                    className={`nav-link ${currentLocale == key ? 'active': ''}`} 
                                    onClick={()=>store.dispatch({type:'SET_LOCALE', payload: key})}>
                                    {translations[key][locales[key]]}
                                </a>
                            ))}
                        </nav>
                        <nav>
                        </nav>
                    </div> */}
                </div>
            </div>
        </footer>
    )
}

Footer.propTypes = {

}
const mapStateToProps = state => ({
    locales: state.Translations.locales,
    currentLocale: state.Translations.currentLocale,
    translations: state.Translations.translations
})
export default connect(mapStateToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx